import { map } from 'ramda';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';

import RadioButton, { IRadioButtonProps } from '@ui/forms/RadioButton';

import padded from '@ui/styled/Padded';
import spaced from '@ui/styled/Spaced';

import { IListItems } from '@folx-types/data';

import theme from '@theme/FolxTheme';

interface IGroupedListProps extends IRadioButtonProps {
	groupName: string;
	header: string;
	listItems: IListItems;
	className?: string;
}

const SpacedColumn = spaced<IFlexColumn>(FlexColumn);
const SpacedRadio = styled(padded<IRadioButtonProps>(RadioButton))`
	border-bottom: 1px solid ${theme.colors.borderGray};
`;

const GroupedList = forwardRef<HTMLInputElement, IGroupedListProps>(
	({ className, groupName, header, listItems, value, ...radioProps }, ref) => {
		return (
			<SpacedColumn className={className} marginBottom="sm">
				<BasicText>{header}</BasicText>
				{map((item: { label: string; value: string }) => {
					return (
						<SpacedRadio
							{...radioProps}
							ref={ref}
							key={`${header} ${item.value}`}
							name={groupName}
							label={item.label}
							value={item.value}
							paddingTop="sm"
							paddingBottom="sm"
							checked={item.value === value}
						/>
					);
				})(listItems)}
			</SpacedColumn>
		);
	}
);

GroupedList.displayName = 'GroupedList';
export default styled(GroupedList)``;
